import {create} from "zustand";

const usePortStore = create((set) => ({
    isPortStatusUpdated: false,

    setPortStatusUpdated: (status) => set({isPortStatusUpdated: status}),
}));

export default usePortStore